module.exports = __webpack_public_path__ + "assets/wechat.81a36711.svg";